import type { DragEvent } from 'react';

/** The drag payload: a subject id, or an empty string for the eraser. */
export const SUBJECT_DRAG = 'application/x-rd-subject';

export function startSubjectDrag(event: DragEvent, subjectId: string | null): void {
  event.dataTransfer.setData(SUBJECT_DRAG, subjectId ?? '');
  event.dataTransfer.effectAllowed = 'copy';
}

/** During dragover only the types are readable, not the data. */
export const isSubjectDrag = (event: DragEvent): boolean => Array.from(event.dataTransfer.types).includes(SUBJECT_DRAG);

/** The dropped subject id, or null for the eraser. */
export const droppedSubject = (event: DragEvent): string | null => event.dataTransfer.getData(SUBJECT_DRAG) || null;

export type CellRef = { periodId: string; weekday: number };

/** A filled cell dragged onto another cell: swap, or copy with Alt. */
export const CELL_DRAG = 'application/x-rd-cell';

export function startCellDrag(event: DragEvent, cell: CellRef): void {
  event.dataTransfer.setData(CELL_DRAG, JSON.stringify(cell));
  event.dataTransfer.effectAllowed = 'copyMove';
}

export const isCellDrag = (event: DragEvent): boolean => Array.from(event.dataTransfer.types).includes(CELL_DRAG);

export function droppedCell(event: DragEvent): CellRef | null {
  try {
    const parsed = JSON.parse(event.dataTransfer.getData(CELL_DRAG)) as Partial<CellRef>;
    return typeof parsed.periodId === 'string' && typeof parsed.weekday === 'number'
      ? { periodId: parsed.periodId, weekday: parsed.weekday }
      : null;
  } catch {
    return null;
  }
}
